var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRadioBulletSelected = function SvgRadioBulletSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    x: 0.5,
    y: 1.251,
    stroke: "currentColor",
    rx: 9.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 5,
    y: 5.751,
    fill: "currentColor",
    rx: 5
  })));
};
export { SvgRadioBulletSelected as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3QgeD0iLjUiIHk9IjEuMjUxIiB3aWR0aD0iMTkiIGhlaWdodD0iMTkiIHJ4PSI5LjUiIHN0cm9rZT0iY3VycmVudENvbG9yIi8+PHJlY3QgeD0iNSIgeT0iNS43NTEiIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCIgcng9IjUiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";